import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppUser } from '../../../../models/app-user.model';
import { UserProperty } from '../../../../models/user-property.model';
import { AppUserService } from '../../../../services/app-user.service';

@Component({
  selector: 'app-user-page',
  templateUrl: './user-page.component.html',
  styleUrl: './user-page.component.scss'
})
export class UserPageComponent {

  public uid: string = '';
  public user: AppUser | null = null;

  /* Estado propio de la página, NO el overlay global: el render es progresivo y
     por pieza (encabezado, ficha, propiedades), con esqueletos que reservan el
     alto final para que nada salte al llegar la respuesta. */
  public loading: boolean = true;

  /* Si el GET falla la pantalla no puede quedarse con el esqueleto girando para
     siempre: el fallo se vuelve un estado explícito dentro de la misma página. */
  public notFound: boolean = false;

  /* Piezas fantasma del esqueleto: solo le dan cuerpo a la ficha y al listado
     mientras loading es true. Van como campos y no como literales en la
     plantilla para no reconstruir el arreglo en cada ciclo de detección. */
  public skeletonFields: null[] = [null, null, null, null, null, null];
  public skeletonProperties: null[] = [null, null];

  /* Única región viva de la pantalla. Vive SIEMPRE en el DOM: un aria-live que
     aparece junto con su texto no se anuncia. */
  public liveMessage: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    public appUserService: AppUserService
  ) {

    this.activatedRoute.params.subscribe(
      async params => {

        this.uid = params['uid'];

        this.getData();

      }
    );

  }

  /* `properties` en `undefined` significa «la respuesta no trae la llave», y en
     esta pantalla eso solo pasa si el backend cambió el contrato. Se trata como
     lista vacía: la pantalla ya explica que no todos los usuarios son
     residentes. */
  get properties(): UserProperty[] {
    return this.user?.properties ?? [];
  }

  get hasProperties(): boolean {
    return this.properties.length > 0;
  }

  /*
   ██████╗ ███████╗████████╗██████╗  █████╗ ████████╗ █████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║  ███╗█████╗     ██║   ██║  ██║███████║   ██║   ███████║
  ██║   ██║██╔══╝     ██║   ██║  ██║██╔══██║   ██║   ██╔══██║
  ╚██████╔╝███████╗   ██║   ██████╔╝██║  ██║   ██║   ██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  // region getData
  async getData(): Promise<void> {

    this.loading = true;
    this.notFound = false;
    this.liveMessage = 'Cargando la información del usuario';

    this.user = await this.appUserService.get(this.uid);

    this.notFound = this.user === null;

    if (this.notFound) {
      this.liveMessage = 'No se pudo cargar la información del usuario';
    } else if (this.hasProperties) {
      this.liveMessage = this.properties.length === 1
        ? `${this.user!.username}: 1 propiedad`
        : `${this.user!.username}: ${this.properties.length} propiedades`;
    } else {
      this.liveMessage = `${this.user!.username} no pertenece a ninguna propiedad`;
    }

    this.loading = false;

  }

}
